import { HYDRATE } from "next-redux-wrapper";
import { ActionsSearchProducts } from "./actions";

const initialState = { data: [], status: "fetch_init", message: "" };

function storeSearchProducts(state = initialState, action) {

	switch (action.type) {

	case HYDRATE:
		return { ...state, ...action.payload.storeSearchProducts };
	case ActionsSearchProducts.LOAD_GET_SEARCH_PRODUCTS:
		return { ...state, data: action.data, status: "fetch_loading" };
	case ActionsSearchProducts.RES_GET_SEARCH_PRODUCTS:
		return { ...state, data: action.data, status: "fetch_result" };
	case ActionsSearchProducts.ERR_GET_SEARCH_PRODUCTS:
		return {
			...state,
			data: action,
			status: "fetch_error",
			message: "Error...",
		};
	default:
		return { ...state };

	}

}

export default storeSearchProducts;
